import { useContext } from 'react';

import { ControllerPropsContext } from '../contexts';
import { ControllerProps } from '../types';

export const useControllerProps = (): ControllerProps => useContext(ControllerPropsContext)!;
